export enum GalleryPageSection {
  DISCOVER_APPS = 'DiscoverApps',
  PRODUCTS = 'Products',
  CATEGORIES = 'Categories',
  HIDDEN = 'Hidden',
}
